export default {
  install(Vue, options) {
    Vue.prototype.$auth = new Vue({
      data: function() {
        return {
          user: undefined,
          isLogin: false,
          type: 'LOGIN', // ACCESS / REFRESH
          onAuth: false,
          lastReq: undefined,
          routeBefore: undefined,
          userPref: {
            morning: '00:00', afternoon: '12:00',
            sticker: '0', vouchLine : 10,
            editStart: 1, printList: 1,
            baseURL: 'api'
          },
          userSession: {
            
          }
        }
      },
      created: function() {
        var isPref  = ns.localStorage.isSet( APP_COD + '_pref' )
        if( isPref ){
            var pref = ns.localStorage.get( APP_COD + '_pref' )
            let prop
            for( prop in pref ){
                if( pref[prop] !== undefined ){
                    this.userPref[prop] = pref[prop] 
                }
            }
        }
        //options.router.push({ path: '/loading' })
        //ApplyRouteGuard.call(this, options.router);
      },
      methods: {
        login(data, callBack) {
          //options.router.push({ path: '/accueil' })
          var hash  = btoa(data.login + ':' + data.password)
          axios.defaults.headers['Authorization'] = 'Basic ' + hash
          axios.post('/', data )
            .then( (response) => {
              if( response.data.access_token !== undefined && response.data.access_token.length > 5 ){
                this.isLogin = true;
                this.onAuth  = false;
                this.user    = response.data;
                this.type    = 'ACCESS';
                axios.defaults.headers.Authorization = 'Bearer ' + response.data.access_token
                ns.sessionStorage.set( APP_COD + "_token", {
                  access_token: response.data.access_token, 
                  expires_in: response.data.expires_on, 
                  token_type: 'Bearer', 
                  scope:null, 
                  refresh_token:'',
                  role: response.data.usr_role
                })
                if( response.data.refresh_token.length > 0 ){
                  ns.localStorage.set( APP_COD + "_token", {
                    access_token: response.data.refresh_token, 
                    expires_in: response.data.expires_on, 
                    token_type: 'Bearer', 
                    scope:null, 
                    refresh_token:'',
                    role: response.data.usr_role
                  })
                }
                callBack(true)
              } else {
                callBack(false)
              }
            })
            .catch( (error) => {
              this.isLogin = false;
              callBack(false)
            });
        },
        logout() {
          axios.post('/', { _path: 'auth', _method: 'DELETE' } )
            .then( (response) => {
              ns.sessionStorage.remove( APP_COD + "_token",)
              ns.localStorage.remove( APP_COD + "_token")
              this.user = undefined;
              this.isLogin = false;
              options.router.push({ path: '/login' })
              return true;
            })
            .catch( (error) => {
              ns.sessionStorage.remove( APP_COD + "_token",)
              ns.localStorage.remove( APP_COD + "_token")
              this.user = undefined;
              this.isLogin = false;
              options.router.push({ path: '/login' })
              return true;
            })  
        },
        checkAuth( callBack ) {
          this.isLogin = false;
          this.onAuth  = true;
          // Chargement Token session
          var isSess  = ns.sessionStorage.isSet( APP_COD + '_token' )
          var isLocal = ns.localStorage.isSet( APP_COD + '_token' )
          if( ns.sessionStorage.isSet( APP_COD + '_token' ) ){
            var session = ns.sessionStorage.get( APP_COD + '_token' )
            axios.defaults.headers.Authorization = 'Bearer ' + session.access_token
            this.type = 'ACCESS'
          } else if ( isLocal ){
            var session = ns.localStorage.get( APP_COD + '_token' )
            axios.defaults.headers.Authorization = 'Bearer ' + session.access_token
            this.type = 'REFRESH'
          } else {
            this.type = 'LOGIN'
          }
          axios.post('/', { _method:'GET', _path: 'auth' } )
          .then( (response) => {
            this.isLogin = true;
            this.onAuth  = false;
            this.user    = response.data;
            this.type    = 'ACCESS';
            axios.defaults.headers.Authorization = 'Bearer ' + response.data.access_token
            ns.sessionStorage.set( APP_COD + "_token", {
              access_token: response.data.access_token, 
              expires_in: response.data.expires_on, 
              token_type: 'Bearer', 
              scope:null, 
              refresh_token:'',
              role: response.data.usr_role
            })
            callBack(true)
          })
          .catch( (error) => {
            if( this.type === 'ACCESS' ){
              this.type = 'REFRESH'
              ns.sessionStorage.remove( APP_COD + '_token' )
              this.checkAuth(callBack)
            } else {
              callBack(false)
            }
          })
        }
      }
    });
  }
};


// WEBPACK FOOTER //
// ./src/plugin/auth.js